<div class="mat-app-background" style="height: 100%; display: flex; flex-direction: column;">
  <mat-card *ngIf="!apiIbkrAvailable" class="alert-card">
    <mat-card-content>
      <p>
        <mat-icon>warning</mat-icon>
        La API de IBKR no está disponible en este momento. Algunas funcionalidades pueden estar limitadas.
      </p>
    </mat-card-content>
  </mat-card>
  <mat-card *ngIf="idCarteraBroker! === '0' && modulo === 'BROKER'" class="alert-card">
    <mat-card-content>
      <p>
        <mat-icon>warning</mat-icon>
        Debe seleccionar una cartera en el modulo {{modulo}}.
      </p>
    </mat-card-content>
  </mat-card>
  <div class="suscripciones-confirmar-container" [ngClass]="{'dark-theme': isDarkTheme}" style="flex: 1; min-height: 0; display: flex; flex-direction: column;">
    <div class="mat-app-background" style="flex: 1; min-height: 0; display: flex; flex-direction: column;">
      <ng-container>
        <!-- Fila 1: título + cartera/subcarteras a la izquierda, métricas a la derecha -->
        <div class="sc-title">
          <div class="sc-title-left">
            <span class="cartera-title-tag">
              <span class="cartera-title-tag__dot"></span>
              CONTROL OPERATIVA: {{cartera}}
            </span>
            <span class="cartera-title-tag" *ngIf="brokerClockTextInput"
                  [matTooltip]="tipoBroker === 'METAAPI' ? 'Hora del servidor del broker' : 'Hora del exchange'">HORA EXCHANGE{{ brokerClockLabelInput ? ' ' + brokerClockLabelInput : '' }}:
              <mat-icon style="font-size:14px; width:14px; height:14px; vertical-align:middle;">schedule</mat-icon>
              {{ brokerClockTextInput }}
            </span>
            <mat-icon style="cursor: pointer; font-size: 18px; width: 18px; height: 18px;" (click)="showHelp()"
              matTooltip="Ayuda">help_outline</mat-icon>

            <!-- Links: cartera + subcarteras -->
            <div class="sib-links" *ngIf="listaSuscripciones && listaSuscripciones.length > 0">
              <span class="sib-label" matTooltip="Cartera">Cart.</span>
              <a *ngIf="tieneVariasSubcarteras" target="_blank" class="sib-name"
                 [matTooltip]="listaSuscripciones[0].nombre"
                 [href]="'/portfolio-labs?idcarteraoptima=' + $any(listaSuscripciones[0]).idcarteraoptima + '&idcartera=' + $any(listaSuscripciones[0]).idsubcarterascartera + '&fecharegistrosuscripcion=' + fecharegistrosuscripcion">
                {{ (listaSuscripciones[0].nombre | slice:0:15) + (listaSuscripciones[0].nombre.length > 15 ? '…' : '') }}
              </a>
              <span *ngIf="!tieneVariasSubcarteras" class="sib-name"
                    [matTooltip]="listaSuscripciones[0].nombre">{{ (listaSuscripciones[0].nombre | slice:0:15) + (listaSuscripciones[0].nombre.length > 15 ? '…' : '') }}</span>
              <ng-container *ngIf="$any(listaSuscripciones[0]).idsubcarteras && $any(listaSuscripciones[0]).subcarteras">
                <span class="sib-sep">|</span>
                <span class="sib-label">Subcart.</span>
                <div class="sib-subcart-wrapper">
                  <span class="sib-subcarteras-trigger">
                    {{ $any(listaSuscripciones[0]).subcarteras.split(',').length }} subcart. ▾
                  </span>
                  <div class="subcart-popup">
                    <ng-container *ngFor="let idModelo of $any(listaSuscripciones[0]).idsubcarteras.split(','); let i = index">
                      <a [href]="'/models?id=' + idModelo.trim() + '&fecharegistrosuscripcion=' + fecharegistrosuscripcion + '&idcarteraoptima=' + ($any(listaSuscripciones[0]).idcarteraoptima ? $any(listaSuscripciones[0]).idcarteraoptima.toString().split(',')[i].trim() : '')"
                         target="_blank" [title]="$any(listaSuscripciones[0]).subcarteras.split(',')[i].trim()">
                        {{ ($any(listaSuscripciones[0]).subcarteras.split(',')[i].trim() | slice:0:15) + ($any(listaSuscripciones[0]).subcarteras.split(',')[i].trim().length > 15 ? '…' : '') }} {{ geticonoscartera($any(listaSuscripciones[0]).subcarteras.split(',')[i].trim()) }}
                      </a>
                    </ng-container>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>

          <!-- Wallet metrics inline -->
          <div class="wallet-metrics-bar" *ngIf="walletMetrics && listaSuscripciones && listaSuscripciones.length > 0">
            <div class="wallet-metric-item">
              <span class="wallet-metric-label">VL</span>
              <span class="wallet-metric-value">{{ walletMetrics.valorLiquidativo | number:'1.2-2' }}</span>
            </div>
            <div class="wallet-metric-item">
              <span class="wallet-metric-label" matTooltip="Capital inicial × Riesgo Máximo % / 100">R. Máx</span>
              <span class="wallet-metric-value">{{ walletMetrics.riesgomaximo | number:'1.2-2' }}</span>
            </div>
            <div class="wallet-metric-item">
              <span class="wallet-metric-label" matTooltip="Riesgo en uso por las posiciones abiertas">R. Act</span>
              <span class="wallet-metric-value">{{ walletMetrics.riesgoActual | number:'1.2-2' }}</span>
            </div>
            <div class="wallet-metric-item"
                [class.wallet-metric--ok]="riesgoDisponible > 0"
                [class.wallet-metric--warn]="riesgoDisponible <= 0">
              <span class="wallet-metric-label">R. Disp</span>
              <span class="wallet-metric-value">{{ riesgoDisponible | number:'1.2-2' }}</span>
            </div>
            <div class="wallet-metric-item"
                [class.wallet-metric--warn]="walletMetrics.margen <= 0">
              <span class="wallet-metric-label">Mrg. Total</span>
              <span class="wallet-metric-value">{{ walletMetrics.margen | number:'1.2-2' }}</span>
            </div>
            <div class="wallet-metric-item"
                [class.wallet-metric--ok]="margenDisponible > 0"
                [class.wallet-metric--warn]="margenDisponible <= 0">
              <span class="wallet-metric-label" matTooltip="VL × MarginCall% / 100 − Margen Total">Mrg. Disp</span>
              <span class="wallet-metric-value">{{ margenDisponible | number:'1.2-2' }}</span>
            </div>
            <div class="wallet-metric-item">
              <span class="wallet-metric-label">MC %</span>
              <span class="wallet-metric-value">{{ walletMetrics.controlMarginCall | number:'1.2-2' }}%</span>
            </div>
          </div>
        </div>

        <!-- Fila 2: toolbar -->
        <div *ngIf="listaSuscripciones && listaSuscripciones.length > 0" class="suscripcion-info-bar">
          <div class="sib-right">
            <!-- Gestor (solo GESTOR) -->
            <div class="sib-gestor" *ngIf="modulo === 'GESTOR'">
              <span class="sib-label">Gestor</span>
              <mat-checkbox class="gray-color" [checked]="true" [disabled]="true"></mat-checkbox>
            </div>

            <!-- Auto + OCO -->
            <mat-slide-toggle class="sib-toggle" color="accent"
              [(ngModel)]="activadoauto"
              [disabled]="!listaSuscripciones[0].suscrito"
              (change)="suscribirModeloAuto($event.checked, listaSuscripciones[0])"
              matTooltip="Automático">
              AUTOMATIZAR
            </mat-slide-toggle>
            <mat-slide-toggle class="sib-toggle" color="accent"
              [(ngModel)]="isOco"
              (change)="onOcoChange($event.checked)"
              matTooltip="Enviar órdenes con Stop Loss y Take Profit (OCO)">
              Ordenes oco
            </mat-slide-toggle>

            <!-- Ver Operaciones / Ver gráficas / Refrescar >
            <a *ngIf="tipoBroker != 'METAAPI'" mat-icon-button [routerLink]="['/broker-operations']" [queryParams]="{idcartera: idcartera, nombre: cartera}"
                matTooltip="Ver Operaciones" target="_blank" color="accent">
              <mat-icon style="font-size:18px;width:18px;height:18px;line-height:18px;">list_alt</mat-icon>
            </a-->
            
            <a mat-icon-button
              (click)="$event.stopPropagation(); listaSuscripciones?.length && openChartsDialog(listaSuscripciones[0])"
              matTooltip="Ver gráficas"
              [class.disabled-icon]="!listaSuscripciones?.length"
              [class.toolbar-btn--active]="showChartsSection">
              <mat-icon style="font-size:18px;width:18px;height:18px;line-height:18px;">bar_chart</mat-icon>
            </a>
            <!-- Operaciones que la automatización no llegó a enviar al broker -->
            <button *ngIf="modulo === 'BROKER' && operacionesNoEnviadas.length" mat-icon-button
              [matMenuTriggerFor]="menuNoEnviadas"
              matTooltip="Operaciones no enviadas al broker">
              <mat-icon class="no-enviadas-icon" [matBadge]="operacionesNoEnviadas.length" matBadgeColor="warn"
                matBadgeSize="small" style="font-size:18px;width:18px;height:18px;line-height:18px;">warning</mat-icon>
            </button>
            <mat-menu #menuNoEnviadas="matMenu" class="no-enviadas-menu" xPosition="before">
              <div class="no-enviadas-panel" (click)="$event.stopPropagation()">
                <div class="no-enviadas-title">No enviadas al broker ({{ operacionesNoEnviadas.length }})</div>
                <table class="no-enviadas-tabla">
                  <tr>
                    <th>ISO</th><th>Tipo</th><th>Estado</th><th>Fecha</th>
                  </tr>
                  <tr *ngFor="let op of operacionesNoEnviadas">
                    <td>{{ op.isooper }}</td>
                    <td [ngClass]="{'salida': op.tipoOperacion === 'SALIDA', 'entrada': op.tipoOperacion === 'ENTRADA'}">
                      {{ op.tipoOperacion }} {{ op.bajista ? '↓' : '↑' }}
                    </td>
                    <td>
                      <mat-icon class="estado-icon" [ngClass]="op.estado === 'ERROR' ? 'text-danger' : 'text-warning'">{{ getEstadoIcon(op.estado) }}</mat-icon>
                      {{ op.estado }}
                    </td>
                    <td>{{ fechaOperacion(op) }}</td>
                  </tr>
                </table>
              </div>
            </mat-menu>

            <ng-content select="[toolbarActions]"></ng-content>
          </div>

        </div>


        <!-- Context Menu (tabla GESTOR) -->
        <ng-template #contextMenu>
          <div class="context-menu" cdkMenu [ngClass]="{'dark-theme': isDarkTheme, 'light-theme': !isDarkTheme}">
            <button class="context-menu-item" cdkMenuItem (click)="onContextMenuAction('enmodelo',selectedElement)">Ver
              en Modelo</button>
            <button class="context-menu-item" cdkMenuItem (click)="onContextMenuAction('grafica',selectedElement)">Ver
              Grafica</button>
          </div>
        </ng-template>

        <app-multicharts-dialog
          *ngIf="showChartsSection"
          [data]="chartsData"
          (operationHovered)="highlightedIsoopers = $event"
          (closed)="showChartsSection = false; highlightedIsoopers = []">
        </app-multicharts-dialog>

        <!-- Paneles opcionales que proyecta el host (p.ej. posiciones / órdenes en /broker) -->
        <ng-content select="[panelesBroker]"></ng-content>

        <div class="row">
          <div class="col-12">

            <div *ngIf=" modulo === 'GESTOR'" class="col-panel-wrapper">
              <h5 class="etiquetas">OPERACIONES - GESTOR - {{cartera}}</h5>

              <!-- Column Visibility Controls for GESTOR -->
              <div class="floating-col-panel" (mouseleave)="contraerColPanel()"
                   [ngClass]="{'expanded': colPanelOpen}">
                <div class="col-panel-toggle" (mouseenter)="expandirColPanel()">
                  <mat-icon>{{colPanelOpen ? 'chevron_left' : 'view_column'}}</mat-icon>
                </div>
                <div class="col-panel-content">
                  <h6 class="col-panel-title mb-2">Columnas</h6>
                  <div class="col-panel-option" *ngFor="let column of tableColumnsOperacionesGestor">
                    <mat-checkbox [checked]="column.isShow" (change)="toggleColumnVisibilityGestor(column.id)" [color]="'primary'">
                      {{column.name}}
                    </mat-checkbox>
                  </div>
                </div>
              </div>

              <div class="table-scroll">
                <cdk-virtual-scroll-viewport #viewportOperacionesGestor item [appendOnly]="false" [tvsItemSize]="24"
                  [headerHeight]="34" class="wrapper mat-elevation-z2">

                  <table cdk-table [dataSource]="opedataGestor" class="tableStyle">
                    <ng-container cdkColumnDef="position">
                      <th cdk-header-cell *cdkHeaderCellDef class="sticky-header"> Nº. </th>
                      <td cdk-cell *cdkCellDef="let element; let i = index;"> {{i + 1}} </td>
                    </ng-container>
                    <ng-container cdkColumnDef="ticker">
                      <th cdk-header-cell *cdkHeaderCellDef class="sticky-header"> ISO </th>
                      <td cdk-cell *cdkCellDef="let element">
                        <span *ngIf="getPairSymbol(element.isooper)"
                          class="pair-indicator">{{getPairSymbol(element.isooper)}}</span>
                        {{element.isooper}}
                      </td>
                    </ng-container>

                    <ng-container cdkColumnDef="precioentradareal">
                      <th cdk-header-cell *cdkHeaderCellDef class="sticky-header"> Precio Entrada </th>
                      <td cdk-cell *cdkCellDef="let element"> {{formatPrice(element.precioentradareal, element)}} </td>
                    </ng-container>

                    <ng-container cdkColumnDef="preciosalidareal">
                      <th cdk-header-cell *cdkHeaderCellDef class="sticky-header"> Precio Salida </th>
                      <td cdk-cell *cdkCellDef="let element"> {{formatPrice(element.preciosalidareal, element)}} </td>
                    </ng-container>

                    <!-- NUEVO: Profit Inicial (Gestor) -->
                    <!--ng-container matColumnDef="profitinicial">
                    <th mat-header-cell *matHeaderCellDef> Profit Inicial </th>
                    <td mat-cell *matCellDef="let element">
                      {{formatPrice(element.profitinicial, element)}}
                    </td>
                  </ng-container-->

                    <!-- NUEVO: Profit Actual (Gestor) -->
                    <!--ng-container matColumnDef="profit">
                    <th mat-header-cell *matHeaderCellDef> Profit Actual</th>
                    <td mat-cell *matCellDef="let element">
                      {{formatPrice(element.profit, element)}}
                    </td>
                  </ng-container-->

                    <ng-container matColumnDef="stoplossinicial">
                      <th mat-header-cell *matHeaderCellDef> Stop Loss Inicial / Broker </th>
                      <td mat-cell *matCellDef="let element"> {{formatPrice(element.stoplossinicial, element)}} </td>
                    </ng-container>

                    <ng-container cdkColumnDef="stoploss">
                      <th cdk-header-cell *cdkHeaderCellDef class="sticky-header"> Stop Loss Actual</th>
                      <td cdk-cell *cdkCellDef="let element"> {{formatPrice(element.stoploss, element)}} </td>
                    </ng-container>

                    <ng-container cdkColumnDef="tipoOperacion">
                      <th cdk-header-cell *cdkHeaderCellDef class="sticky-header">Tipo </th>
                      <td cdk-cell *cdkCellDef="let element"> {{element.tipoOperacion}} {{element.bajista ? '↓' : '↑'}}
                      </td>
                    </ng-container>

                  
                    <ng-container cdkColumnDef="fecha">
                      <th cdk-header-cell *cdkHeaderCellDef class="sticky-header"> Fecha </th>
                      <td cdk-cell *cdkCellDef="let element">
                        {{element.fechaOperacion}}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="estado">
                      <th mat-header-cell *matHeaderCellDef> Estado </th>
                      <td mat-cell *matCellDef="let element">
                        <mat-icon [matTooltip]="element.estado" class="estado-icon" [ngClass]="{'text-success': element.estado === 'COMPLETADO' || element.estado === 'FILLED', 
                                  'text-warning': element.estado === 'EN_PROCESO',
                                  'text-danger': element.estado === 'RECHAZADO'}">
                          {{getEstadoIcon(element.estado)}}
                        </mat-icon>
                      </td>
                    </ng-container>

                    <tr cdk-header-row *cdkHeaderRowDef="displayedColumnsOperacionesGestor; sticky: true"
                      class="sticky-header"></tr>
                    <tr cdk-row *cdkRowDef="let row; columns: displayedColumnsOperacionesGestor;"
                      [ngClass]="{'pair-row': getPairSymbol(row.isooper), 'row-highlighted': highlightedIsoopers.includes(row.isooper)}" (contextmenu)="onContextMenu($event, row)">
                    </tr>
                  </table>
                </cdk-virtual-scroll-viewport>
              </div>
            </div>
          </div>

        </div>


      </ng-container>
    </div>
  </div>

  <mat-dialog-actions align="end">
    <!--button mat-button mat-dialog-close>Cancelar</button>
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Aceptar</button-->
  </mat-dialog-actions>

</div>